
/*
 * src/web/components/dashboard-page.jsx
 */

import React from 'react'
import ReactDOM from 'react-dom'
import connect, { calcSummaryData, calcMembersData } from '../../connects/dashboard-page'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import RightSidePage from './right-side-page.jsx'
import ChartView from 'react-highcharts'
import DashboardUserPage from './dashboard-user-page.jsx'
import Tooltip from 'react-toolbox/lib/tooltip';
import _ from 'lodash'
import moment from 'moment'

const TooltipIconButton = Tooltip(IconButton)

const SUMMARY_CHART_HEIGHT = 300
const MEMBERS_CHART_EACH_HEIGHT = 40
const COLORS = {
  diary:   '#2f7ed8',
  kpi:     '#0d233a',
  memo:    '#8bbc21',
  like:    '#910000',
  comment: '#1aadce',
  line1:   '#492970',
  line2:   '#f28f43'
}

class DashboardPage extends React.Component {
  state = {
    innerWidth: undefined,
    summary_diary: true,
    summary_kpi: true,
    summary_memo: true,
    summary_like: true,
    summary_comment: true,
    members_diary: true,
    members_kpi: true,
    members_memo: true,
    members_like: true,
    members_comment: true,
    summaryChart: undefined,
    membersChart: undefined,
  }
  onClose = ()=> this.props.updateUI({ user: undefined })

  componentDidMount() {
    this.setState({ innerWidth: ReactDOM.findDOMNode(this).clientWidth })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.summary !== nextProps.summary && nextProps.summary)
      this.setState({ summaryChart: this.generateSummaryChart(nextProps, this.state) })
    if ((this.props.posts !== nextProps.posts || this.props.replies !== nextProps.replies) && nextProps.posts && nextProps.replies)
      this.setState({ membersChart: this.generateMembersChart(nextProps, this.state) })
  }

  componentDidUpdate(prevProps, prevState) {
    let onMembersXAxisClick = this.onMembersXAxisClick
    setTimeout(()=> {
      const xAxisLabels = document.getElementsByClassName('members-x-axis')
      for (let i = 0; i < xAxisLabels.length; i ++) {
        xAxisLabels[i].onclick = onMembersXAxisClick
      }
    }, 100)
  }

  onMembersXAxisClick = (event)=> {
    const post = _.find(this.props.posts, (_post)=> _post.user.user_id == parseInt(event.target.id))
    if (post && post.user) {
      const newUi = { user: post.user }
      setTimeout(()=> this.props.updateUI(newUi), 0)
    }
    return false
  }

  toggleSummaryChart = (key)=> {
    const _key = `summary_${key}`
    const _state = Object.assign({}, this.state, { [_key]: !this.state[_key] })
    const newState = {
      [_key]: _state[_key],
      summaryChart: this.generateSummaryChart(this.props, _state),
    }
    setTimeout(()=> this.setState(newState), 0)
    return false
  }

  toggleMembersChart = (key)=> {
    const _key = `members_${key}`
    const _state = Object.assign({}, this.state, { [_key]: !this.state[_key] })
    const newState = {
      [_key]: _state[_key],
      membersChart: this.generateMembersChart(this.props, _state),
    }
    setTimeout(()=> this.setState(newState), 0)
    return false
  }

  generateSummaryChart = (props, state)=> {
    const { t, summary } = props
    const summaryData = calcSummaryData(summary, {
      diary: state.summary_diary,
      kpi: state.summary_kpi,
      memo: state.summary_memo,
      like: state.summary_like,
      comment: state.summary_comment,
    })
    return {
      chart: {
        type: 'column',
        height: SUMMARY_CHART_HEIGHT,
      },
      title: { text: undefined },
      credits: { enabled: false },
      exporting: { enbaled: false },
      plotOptions: { column: { stacking: 'normal' }},
      legend: { maxHeight: 20 },
      xAxis: {
        categories: summaryData.x_axis,
        offset: SUMMARY_CHART_HEIGHT * -0.4 + 64,
        lineWidth: 0,
        tickWidth: 0,
        minorGridLineWidth: 0,
        labels: {
          autoRotation: false,
          style: { whiteSpace: 'nowrap' },
        }
      },
      yAxis: [{
        min: 0,
        height: SUMMARY_CHART_HEIGHT * 0.6 - 20,
        reversedStacks: false,
        title: { text: t('label:投稿数') }
      }, {
        min: 0,
        height: SUMMARY_CHART_HEIGHT * 0.4 - 60,
        top: SUMMARY_CHART_HEIGHT * 0.6 + 20,
        offset: 0,
        reversed: true,
        reversedStacks: false,
        title: { text: t('label:リアクション数') }
      }, {
        min: 0,
        opposite: true,
        height: SUMMARY_CHART_HEIGHT * 0.6 - 20,
        title: { text: t('label:1人平均') }
      }, {
        min: 0,
        opposite: true,
        reversed: true,
        height: SUMMARY_CHART_HEIGHT * 0.4 - 60,
        top: SUMMARY_CHART_HEIGHT * 0.6 + 20,
        offset: 0,
        title: { text: t('label:投稿あたり') }
      }],
      series: [{
        color: COLORS.diary,
        name: t('diary:diary'),
        data: summaryData.posts_data.diary,
        stack: 'posts',
        yAxis: 0,
        events: { legendItemClick: ()=> this.toggleSummaryChart('diary') },
      }, {
        color: COLORS.kpi,
        name: t('diary:kpi'),
        data: summaryData.posts_data.kpi,
        stack: 'posts',
        yAxis: 0,
        events: { legendItemClick: ()=> this.toggleSummaryChart('kpi') },
      }, {
        color: COLORS.memo,
        name: t('diary:memo'),
        data: summaryData.posts_data.memo,
        stack: 'posts',
        yAxis: 0,
        events: { legendItemClick: ()=> this.toggleSummaryChart('memo') },
      }, {
        color: COLORS.like,
        name: t('label:いいね'),
        data: summaryData.replies_data.like,
        stack: 'replies',
        yAxis: 1,
        events: { legendItemClick: ()=> this.toggleSummaryChart('like') },
      }, {
        color: COLORS.comment,
        name: t('label:コメント'),
        data: summaryData.replies_data.comment,
        stack: 'replies',
        yAxis: 1,
        events: { legendItemClick: ()=> this.toggleSummaryChart('comment') },
      }, {
        color: COLORS.line1,
        type: 'spline',
        name: t('label:平均投稿数'),
        data: summaryData.posts_data.avg,
        yAxis: 2,
        showInLegend: false,
      }, {
        color: COLORS.line2,
        type: 'spline',
        name: t('label:平均リアクション数'),
        data: summaryData.replies_data.avg,
        yAxis: 3,
        showInLegend: false,
      }]
    }
  }

  generateMembersChart = (props, state)=> {
    const { t, posts, replies } = props
    const { innerWidth } = state
    const membersData = calcMembersData(posts, replies, {
      diary: state.members_diary,
      kpi: state.members_kpi,
      memo: state.members_memo,
      like: state.members_like,
      comment: state.members_comment,
    })
    return {
      chart: {
        type: 'bar',
        height: membersData.x_axis.length * MEMBERS_CHART_EACH_HEIGHT + 90,
      },
      title: { text: undefined },
      credits: { enabled: false },
      exporting: { enbaled: false },
      plotOptions: {
        bar: { stacking: 'normal' },
        series: {
          cursor: 'pointer',
          events: {
            click: (event)=> this.props.updateUI({ user: event.point.category })
          }
        }
      },
      tooltip: {
        formatter: function(tooltip) {
          return tooltip.defaultFormatter.call(Object.assign({}, this, { key: this.key.name }), tooltip)
        }
      },
      xAxis: {
        categories: membersData.x_axis,
        offset: innerWidth * 0.4 - 50,
        width: 0,
        opposite: true,
        lineWidth: 0,
        tickWidth: 0,
        minorGridLineWidth: 0,
        labels: {
          useHTML: true,
          autoRotation: false,
          align: 'left',
          reserveSpace: false,
          formatter: function() {
            return `<span style='cursor: pointer; font-weight: bold;' class='members-x-axis' id='${this.value.user_id}'>${this.value.name}</span>`
          },
        },
      },
      yAxis: [{
        min: 0,
        width: innerWidth * 0.6 - 30,
        left: innerWidth * 0.4 + 30,
        opposite: true,
        reversedStacks: false,
        title: { text: t('label:投稿数')},
      }, {
        min: 0,
        width: innerWidth * 0.4 - 30,
        left: 0,
        offset: 0,
        opposite: true,
        reversed: true,
        reversedStacks: false,
        title: { text: t('label:リアクション数') },
      }],
      series: [{
        color: COLORS.like,
        name: t('label:いいね'),
        data: membersData.replies_data.like,
        stack: 'replies',
        yAxis: 1,
        events: { legendItemClick: ()=> this.toggleMembersChart('like') },
      }, {
        color: COLORS.comment,
        name: t('label:コメント'),
        data: membersData.replies_data.comment,
        stack: 'replies',
        yAxis: 1,
        events: { legendItemClick: ()=> this.toggleMembersChart('comment') },
      }, {
        color: COLORS.diary,
        name: t('diary:diary'),
        data: membersData.posts_data.diary,
        stack: 'posts',
        yAxis: 0,
        events: { legendItemClick: ()=> this.toggleMembersChart('diary') },
      }, {
        color: COLORS.kpi,
        name: t('diary:kpi'),
        data: membersData.posts_data.kpi,
        stack: 'posts',
        yAxis: 0,
        events: { legendItemClick: ()=> this.toggleMembersChart('kpi') },
      }, {
        color: COLORS.memo,
        name: t('diary:memo'),
        data: membersData.posts_data.memo,
        stack: 'posts',
        yAxis: 0,
        events: { legendItemClick: ()=> this.toggleMembersChart('memo') },
      }, {
        color: COLORS.line1,
        type: 'line',
        enableMouseTracking: false,
        marker: { enabled: false },
        dashStyle: 'dot',
        name: t('label:平均投稿数'),
        data: _.times(membersData.x_axis.length, _.constant(membersData.avg_posts)),
        yAxis: 0,
        showInLegend: false,
      }, {
        color: COLORS.line2,
        type: 'line',
        enableMouseTracking: false,
        marker: { enabled: false },
        dashStyle: 'dot',
        name: t('label:平均リアクション数'),
        data: _.times(membersData.x_axis.length, _.constant(membersData.avg_replies)),
        yAxis: 1,
        showInLegend: false,
      }]
    }
  }

  prevMonth = ()=> this.props.prevMonth(this.props)
  nextMonth = ()=> this.props.nextMonth(this.props)
  exportUrl = ()=> window.open(this.props.exportUrl(this.props))

  render() {
    const {
      t,
      group,
      ui,
      isFetching,
      summary,
      posts,
      replies,
      exportUrl,
      isShowTimeStamp,
    } = this.props
    const endDate = ui.startDate.clone().endOf('month')

    return (
      <div>
      <RightSidePage title={t('label:インサイト')} icon='insights'
          rightAction={<IconButton icon='cloud_download' key='icon' onClick={this.exportUrl} />} >
        <div style={{ paddingLeft: 10 }}><strong>{t('label:月次提出推移')}</strong></div>
        {this.state.summaryChart && <ChartView config={this.state.summaryChart} isPureConfig={true} /> }
        {isFetching && !this.state.summaryChart &&
          <div style={{ height: SUMMARY_CHART_HEIGHT, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ProgressBar type='circular' multicolor mode='indeterminate' /></div>}
        <div style={{ paddingLeft: 10, paddingTop: 10 }}>
          <strong>{t('label:日報提出状況')}</strong>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button icon='navigate_before' onClick={this.prevMonth} />
          <span>{ui.startDate.format(t('format:month'))}</span>
          <Button icon='navigate_next' onClick={this.nextMonth} disabled={endDate.isAfter(moment())} />
        </div>
        {this.state.membersChart && <ChartView config={this.state.membersChart} isPureConfig={true} /> }
        {isFetching && !this.state.membersChart &&
          <div style={{ height: SUMMARY_CHART_HEIGHT, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ProgressBar type='circular' multicolor mode='indeterminate' /></div>}
        {!isFetching && !summary && !posts && !replies &&
          <div>{t('label:日報提出状況の取得に失敗しました')}</div>}
        {isShowTimeStamp && ui.user && <DashboardUserPage group={group} user={ui.user} onClose={this.onClose} open={!!ui.user} startDate={ui.startDate} />}
      </RightSidePage>
      </div>
    )
  }
}

export const RawDashboardPage = DashboardPage
export default connect(DashboardPage)



// WEBPACK FOOTER //
// ./src/web/components/dashboard-page.jsx